import React, { Component } from "react";
import { Link } from "react-router-dom";
import API from "../../../../../../../apiService";
export default class Puskesmas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ref_pkm: [],
    };
  }

  componentDidMount() {
    this.getPkm();
  }
  getPkm = async () => {
    const res = await API.get1("/standalone/puskesmas");
    if (res.code === 200) {
      this.setState({
        ref_pkm: res.data,
      });
    }
  };
  render() {
    let puskesmas = this.state.ref_pkm.map((data, key) => {
      return (
        <div key={key} className="col-md-3">
          <Link to={{ pathname: '/service/cari-data', param: { data} }}>
            <div className="card">
              <div className="card-body ">
                <div className="text-center">
                  <img
                    className="avatar avatar-xl align-center"
                    src={data.photo}
                    alt="img"
                  />
                </div>
              </div>
              <div className="card-footer text-center">{data.name}</div>
            </div>
          </Link>
        </div>
      );
    });
    return (
      <div className="main-content h-100vh">
        <div className="container-fluid">
          <div className="container">
            <div className="row align-item-center text-left">
              <div className="col-lg-12 my-6">
                <h1 className=" display-3 text-info">Pendaftaran Pasien</h1>
                <p className="lead ">Pilih Puskesmas yang Anda inginkan</p>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid h-100vh pt-3 bg-white shadow-lg mt--5">
          <div className="container px-5">
            <div className="row">
                <div className="row col-md-12">{puskesmas}</div>
              </div>
          </div>
        </div>
      </div>
    );
  }
}
